import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Easie from '../../../src/Easie.js'; // easing
import Helper from '../../../src/Helper.js'; // easing

// import lightbox from 'lightbox2/dist/js/lightbox-plus-jquery.js';

// https://fslightbox.com/javascript/documentation/basic#events
import fslightboxf from 'fslightbox';


import './style.scss';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo common');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            new ModuleFeature();
        });
    }
}

class ModuleFeature {
    
    constructor() {
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        if(!isMobile.check()) {
            setTimeout(() => { this.task1() },0); // prima l'immagine centrale
        }
    }
    
    /**
     * Lightbox
     * @returns {undefined}
     */
    task1() {
        
        refreshFsLightbox();
        
        // tutti i lightbox-trigger aprono la lightbox gallery di pagina
        // ad esempio: <a href="#" data-lightbox-trigger>Apri la gallery di pagina</a>
        var $lightboxTriggers = document.querySelectorAll('[data-lightbox-trigger]');
        $lightboxTriggers.forEach(($lightboxTrigger,i) => {
            $lightboxTrigger.addEventListener('click',(e) => {
                e.preventDefault();
                fsLightbox.open(0);     
            });
            
        });

        /*
        lightbox.option({
            resizeDuration: 200,
            wrapAround: true,
            albumLabel: '',
            disableScrolling : false,
            positionFromTop: 50
        });
        */
    }
    
    
}

// export
export default new Module();